// removed by extract-text-webpack-plugin
module.exports = {"home":"home__3Ym7N","content":"content__2sy80","options":"options__3BftW","option-base":"option-base__16jng","name":"name__AG7fI","details":"details__3SQxT","emoji":"emoji__3io72"};


//////////////////
// WEBPACK FOOTER
// ./routes/teams/teamManagement/style.css
// module id = Gvj+
// module chunks = 14